import { createContext } from 'react';
import { TableauClient } from '~/common';

const context = createContext<TableauClient | undefined>(undefined);

const { Provider, Consumer } = context;

export { Provider, Consumer };
export default context;
